import { MEMBER } from '_constants';
import { UserProfileApiProvider } from '../services/userprofile.services';
import { fetchPersonSettings, updatePersonSettings } from '../services/member.services';
import { isResponseSuccess } from 'helpers';

const setOutOfOffice = (memberKey, oooDates) => async (dispatch) => {
  try {
    dispatch({ type: MEMBER.START_SET_OUTOFOFFICE });
    const response = await dispatch(UserProfileApiProvider.setOutOfOffice(memberKey, oooDates));
    dispatch({ type: MEMBER.SETTING_OUTOFOFFICE, payload: response.data });
    return response;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  } finally {
    dispatch({ type: MEMBER.END_SET_OUTOFOFFICE });
  }
};

const updateOutOfOffice = (outOfOfficeKeys, oooDates) => async (dispatch) => {
  dispatch({ type: MEMBER.START_UPDATING_OUTOFOFFICE });
  try {
    const response = await dispatch(UserProfileApiProvider.updateOutOfOffice(outOfOfficeKeys, oooDates));
    dispatch({ type: MEMBER.UPDATING_OUTOFOFFICE, payload: response.data });
    return response;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  } finally {
    dispatch({ type: MEMBER.END_UPDATING_OUTOFOFFICE });
  }
};

const deleteOutOfOffice = (memberKey, outofofficekey) => async (dispatch) => {
  try {
    dispatch({ type: MEMBER.START_DELETING_OUTOFOFFICE });
    const response = await dispatch(UserProfileApiProvider.deleteOutOfOffice(memberKey, outofofficekey));
    dispatch({ type: MEMBER.DELETING_OUTOFOFFICE });
    return response;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  } finally {
    dispatch({ type: MEMBER.END_DELETING_OUTOFOFFICE });
  }
};

const getPersonSettings = (personId) => async (dispatch) => {
  const response = await dispatch(fetchPersonSettings(personId));
  if (isResponseSuccess(response)) {
    return response.data;
  }
};

const updateAgentSettings = (personId, personSettings) => async (dispatch) => {
  const response = await dispatch(updatePersonSettings(personId, personSettings));
  if (isResponseSuccess(response)) {
    return response.data;
  }
};

export const userprofileActions = {
  setOutOfOffice,
  updateOutOfOffice,
  deleteOutOfOffice,
  getPersonSettings,
  updateAgentSettings
};
